
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(188|915)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
